import { get } from 'Utils/common';
import { INVESTMENT_STEPS, INVESTMENT_STEPS_CONST, INVESTMENT_STEP_BY_STATUS } from 'Config/constans';
import { INVESTMENT_STATUS, ACCREDITATION_PROFILE_STATUS, PROFILE_TYPES } from 'Const/investment';
import * as ACCREDITATION_METHODS from 'Config/accreditation-methods';

export default {
  investmentData: state => state.investmentData,
  investmentDataLoading: state => state.investmentDataLoading,
  investmentDataLoaded: state => state.investmentDataLoaded,
  investmentProfileList: (state, getters, rootState, rootGetters) => rootGetters['profile/investmentProfileList'],
  investmentList: state => state.investmentList,
  investmentListLoading: state => state.investmentListLoading,
  investmentListLoaded: state => state.investmentListLoaded,
  // Filter pending investment list to exclude canceled by manager
  investmentListPending: state => state.investmentList.filter(item => item.status !== INVESTMENT_STATUS.CANCELED_BY_MANAGER),
  investmentListCompleted: state => (
    state.investmentList.filter(item => item.status === INVESTMENT_STATUS.COMPLETED)
  ),
  investmentListCompletedSuccessful: state => state.investmentListCompletedSuccessful,
  investmentNewUpdatesDocumentsList: (state, getters) => {
    const used = {};
    return getters.investmentsNewUpdatesDocumentsList.filter((obj) => {
      if (used[obj.farm.slug]) {
        return false;
      }
      used[obj.farm.slug] = true;
      return true;
    });
  },
  investmentsNewUpdatesDocumentsList: (state) => {
    const filtered = state.investmentListCompletedSuccessful
      .filter(item => item.farm.updates_document_folder && item.farm.updates_document_folder
        .some(flag => flag?.meta_data?.read === false));
    return filtered;
  },
  investmentNewTaxDocumentsList: (state) => {
    const items = [];
    //  Only successfully closed farm needed
    // For each investment
    state.investmentListCompletedSuccessful.forEach((item) => {
      // Get is investment has new docs
      const hasNewDocs = item.tax_documents && item.tax_documents.some(flag => flag.read === false);
      // Check if it farm was not added already in list
      if (hasNewDocs && !items.some(addedItem => addedItem.farm.slug === item.farm.slug)) {
        items.push(item);
      }
    });
    return items;
  },
  createModel: state => state.createModel,
  stepModels: state => state.stepModels,
  shareNumber: state => (
    (state.stepModels.amount && state.stepModels.amount.number_of_shares)
    || state.createModel.number_of_shares
  ),
  sharePrice: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.price_per_share;
  },
  unitPrice: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.raised / farmData.units;
  },
  isUnitType: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.isUnitType;
  },
  isUnitOfferingType: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.isInvestUnitType;
  },
  amount: (state, getters) => {
    if (getters.isUnitType) {
      return getters.shareNumber * getters.unitPrice;
    }
    return getters.shareNumber * getters.sharePrice;
  },
  acresNumber: (state, getters) => (getters.shareNumber / 10) || 0,
  /**
   * Which is max step you can go on refresh
   * by investment process status loaded from api
   * @param state
   * @returns {number}
   */
  maxStepIndexByStatus: (state) => {
    const statusNumber = state.investmentData.status;
    const step = INVESTMENT_STEP_BY_STATUS[statusNumber];
    if (!step) return -1;
    return INVESTMENT_STEPS.findIndex(stepItem => stepItem.value === step);
  },
  sharesOrUnits: (state, getters, rootState, rootGetters) => {
    const farmData = rootGetters['farm/farmData'];
    return farmData.getAssetTypeTitlePlural(2);
  },
  selectedProfileId: (state, getters) => get(
    getters.stepModels,
    'ownership.$serverData.profile_id',
    state.selectedProfileId,
  ),
  selectedProfile: (state, getters) => (
    getters.investmentProfileList.find(item => item.id === getters.selectedProfileId)
  ),
  investmentIsSdira: (state, getters) => (
    Boolean(getters.selectedProfile && getters.selectedProfile.type === PROFILE_TYPES.SDIRA)
  ),
  investmentIsEntity: (state, getters) => (
    Boolean(getters.selectedProfile && getters.selectedProfile.type === PROFILE_TYPES.ENTITY)
  ),
  investmentIsSignatureComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.SIGNATURES];
    if (!model) return false;
    // Should be 7 as checkbox value
    return model.$serverData.checkboxes === 7
      // sdira doesn't requires to sign docusign
      && (getters.investmentIsSdira
      // rest profile types is requires
      // 2 DOCS IF FARM TYPE IS UNIT OFFERING
      || (getters.isUnitOfferingType
        ? (model.$serverData.subscription_agreement && model.$serverData.operating_agreement)
        : model.$serverData.subscription_agreement));
  },
  investmentIsFundingComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.FUNDING];
    if (!model) return false;
    return Boolean(model.$serverData && model.$serverData.funding_source);
  },
  investmentIsAccreditationComplete: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.ACCREDITATION];
    if (!model) return false;
    if (model.$serverData.method === ACCREDITATION_METHODS.LICENSE) {
      return Boolean(model.$serverData.license && model.$serverData.license.crd);
    }
    const files = (model.$serverData || {}).files_upload;
    return Boolean(files && Array.isArray(files) && files.length);
  },
  // Is reset signature needed in case when it required
  investmentIsSignatureResetNeeded: (state, getters) => {
    const model = getters.stepModels[INVESTMENT_STEPS_CONST.SIGNATURES];
    if (!model) return false;
    // if some checkboxes was send, need to reset (e.g. in SDIRA case)
    if (model.$serverData.checkboxes) return true;
    // IF FARM TYPE IS UNIT OFFERING
    if (getters.isUnitOfferingType) {
      return getters.investmentIsSignatureComplete
        || model.$serverData.subscription_agreement
        || model.$serverData.operating_agreement;
    }
    return getters.investmentIsSignatureComplete
      || model.$serverData.subscription_agreement;
  },
  selectedProfileAccreditedDays: (state, getters) => (
    (getters.selectedProfile || {}).accreditation_type === 'income' ? 365 : 90
  ),
  isSelectedProfileAccredited: (state, getters) => {
    const {
      accreditation_status: status,
      accreditation_date: date,
    } = getters.selectedProfile || {};
    if ((status !== ACCREDITATION_PROFILE_STATUS.APPROVED && status !== ACCREDITATION_PROFILE_STATUS.EXPIRED_SOON) || !date) return false;
    // Accredited period for income is 365 for rest types is 90
    const accreditedPeriod = 864e5 * getters.selectedProfileAccreditedDays; // 864e5 - ms in day
    return (Date.now() - Date.parse(date)) < accreditedPeriod;
  },
  isSelectedProfileAccreditedImportant: (state, getters) => (
    getters.selectedProfile && getters.selectedProfile.accreditation_permanent_approved
  ),
  reInitiateTransactionInvestmentListItemLoading: state => state.reInitiateTransactionInvestmentListItemLoading,
  investmentSingleData: state => state.investmentSingleData,
  investmentSingleDataLoading: state => state.investmentSingleDataLoading,
  investmentIsFinished: (state, getters) => (
    getters.investmentList.some(item => String(item.id) === String(getters.investmentData.id))
  ),
};
